import { ArrowRightOutlined } from '@ant-design/icons'
import Plan from '@components/membership/plan/Plan'
import Page from '@components/Page/Page'
import { Venue } from '@components/venue/Venue'
import { AvailableLocale, Lang } from '@models/Lang'
import { useAppSelector } from '@store/hooks'
import { selectEventById } from '@store/membership/EventReducer'
import { Card, Descriptions, Select, Space, Typography } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { langList } from '../../../factories/Utils'

const { Text } = Typography

const InformationsTab = () => {
  const { eventId } = useParams()
  const event = useAppSelector(selectEventById(Number(eventId)))
  const [selectedLangCode, setSelectedLangCode] = useState<AvailableLocale>(
    langList[0].code
  )

  if (!event) {
    return <></>
  }

  return (
    <Page>
      <Card
        variant="borderless"
        style={{ borderRadius: 12, overflow: 'hidden' }}
      >
        <Space orientation="vertical" size={4} style={{ width: '100%' }}>
          <Select
            defaultValue={selectedLangCode}
            style={{ width: 120, position: 'absolute', right: 20, top: 20 }}
            onChange={(val) => setSelectedLangCode(val)}
            options={langList.map((lang: Lang) => ({
              value: lang.code,
              label: <>{`${lang.flag} ${lang.name}`}</>,
            }))}
          />

          <Descriptions
            layout="vertical"
            column={1}
            styles={{
              content: { paddingBottom: 15 },
              label: { paddingBottom: 0 },
            }}
          >
            <Descriptions.Item label={'Title'} style={{ paddingBottom: 5 }}>
              {event[selectedLangCode].title}
            </Descriptions.Item>
            <Descriptions.Item
              label={'Description'}
              style={{ paddingBottom: 5 }}
            >
              {event[selectedLangCode].description}
            </Descriptions.Item>
            <Descriptions.Item label={'Date'} style={{ paddingBottom: 5 }}>
              {
                <Space>
                  {dayjs(event.start).format('DD MMMM YYYY HH:mm')}
                  <ArrowRightOutlined />
                  {dayjs(event.end).format('DD MMMM YYYY : HH:mm')}
                </Space>
              }
            </Descriptions.Item>

            <Descriptions.Item label={'Location'} style={{ paddingBottom: 5 }}>
              <Space size={20}>
                {event.venue && <Venue.Avatar id={event.venue} />}
                {event.address && <Text>{event.address}</Text>}
                {!event.venue && !event.address && 'No location provided'}
              </Space>
            </Descriptions.Item>

            <Descriptions.Item
              label={'Visible by'}
              style={{ paddingBottom: 5 }}
            >
              <Space wrap>
                {event.membershipPlans?.map((plan) => (
                  <Plan.Tag key={plan} id={plan} showProgram />
                ))}
              </Space>
            </Descriptions.Item>
          </Descriptions>
        </Space>
      </Card>
    </Page>
  )
}

export default InformationsTab
